var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 15.5L25.875 6.375C26.375 5.875 26.375 5.125 25.875 4.625C25.375 4.125 24.625 4.125 24.125 4.625L15 13.75L5.875 4.625C5.375 4.125 4.625 4.125 4.125 4.625C3.625 5.125 3.625 5.875 4.125 6.375L13.25 15.5L4.125 24.625C3.625 25.125 3.625 25.875 4.125 26.375C4.375 26.625 4.625 26.75 5 26.75C5.375 26.75 5.625 26.625 5.875 26.375L15 17.25L24.125 26.375C24.375 26.625 24.75 26.75 25 26.75C25.25 26.75 25.625 26.625 25.875 26.375C26.375 25.875 26.375 25.125 25.875 24.625L16.75 15.5Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.d3f30ecc246a402853982de5d2e2e467.svg";
export { ForwardRef as ReactComponent };